/* External */
import { useIntl } from 'react-intl';

/* Hooks */
import { useUserAccount } from '../providers/UserProvider';

/* Utils */
import {
  BUSINESS_CAMPAIGN,
  Country,
  OTT_SSLA_DOMAINS,
  MessagesUpSellGranHermanoUser,
} from '../utils/constants';
import { IS_UPSELL_GRAN_HERMANO_ACTIVE } from '../utils/env';

export default function useGetUpsellMessage() {
  const { formatMessage } = useIntl();

  const {
    iso2Code,
    msoProvider,
  } = useUserAccount() || {};
  const isGranHermanoUser = BUSINESS_CAMPAIGN.has(msoProvider);
  const isArgentinaUser = iso2Code.toLowerCase() === Country.ARGENTINA;

  const upSellMessagesSSLA = MessagesUpSellGranHermanoUser.bannerGranHermanoSSLA;
  const upSellMessagesAR = MessagesUpSellGranHermanoUser.bannerGranHermanoArgentina;

  const mustSetGranHermanoMessages = IS_UPSELL_GRAN_HERMANO_ACTIVE && isGranHermanoUser;

  const upsellMessages = [
    {
      isThisMessage: () => (
        isArgentinaUser && isGranHermanoUser
      ),
      ...upSellMessagesAR,
      link: `${upSellMessagesSSLA.link + OTT_SSLA_DOMAINS.gh}`,
    },
    {
      isThisMessage: () => (
        !isArgentinaUser && isGranHermanoUser
      ),
      ...upSellMessagesSSLA,
      link: `${upSellMessagesSSLA.link + OTT_SSLA_DOMAINS.ya}`,
    },
  ];

  const data = upsellMessages.find(({ isThisMessage }) => isThisMessage());

  if (mustSetGranHermanoMessages) {
    return {
      upsellMessage: data?.message
        && formatMessage({ id: data?.message }),
      upsellLink: data?.link,
    };
  }

  return {
    upsellMessage: '',
    upsellLink: '',
  };
}
